import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=388e7a46"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports